


















import Vue from 'vue'
import './CastBadge.scss'
import { Popover } from 'element-ui'

export default Vue.extend({
  name: 'CastBadge',
  props: {
    icon: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    description: {
      type: String,
      required: true
    },
    compact: {
      type: Boolean,
      required: false,
      default: false
    },
    popoverWidth: {
      type: Number,
      required: false,
      default: 150
    }
  },
  components: {
    'el-popover': Popover,
  }
})
